<template>
  <el-card
    shadow="always"
    class="widget small-widget"
    v-loading="loading"
    :body-style="{ padding: '10px' }"
  >
    <div class="widget-header flex col grid-12" v-if="text != 'Total de GPS'">
      <!-- caja derecha -->
      <div class="box flex justify-flex-end col-9">
        <div class="box widget-icon-box mr-10 animated fadeInRight">
          <slot name="icon">
            <i class="widget-icon accent-text fs-30" :class="icon"></i>
          </slot>
        </div>
        <div
          class="widget-info box grow animated fadeInLeft flex column justify-flex-start align-content-flex-end"
        >
          <el-row>
            <el-col :span="12">
              <div class="o-050 widget-title">
                {{ text }}
              </div>
              <el-tooltip
                class="item box"
                effect="dark"
                :content="total.toString()"
                placement="top-start"
              >
                <span class="pb-0 pl-0 black-text" style="font-weight: 700">
                  <slot name="total" :total="total">{{
                    total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}</slot>
                </span>
              </el-tooltip>
            </el-col>
            <!-- <el-col :span="12" v-if="text == 'Total de GPS'">
              <div class="o-050 widget-title ">
                {{ text2 }}
              </div>
              <el-tooltip
                class="item box"
                effect="dark"
                :content="total2.toString()"
                placement="top-start"
              >
                <span
                  class=" pb-0 pl-0 black-text"
                  style="font-weight: 700"
                >
                  <slot name="total" :total="total2">{{
                    total2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}</slot>
                </span>
              </el-tooltip>
            </el-col> -->
          </el-row>
        </div>
      </div>

      <!-- caja izquierda -->
      <div
        v-if="percent || count"
        class="box flex column justify-flex-end col-3"
        style="font-weight: 200; font-size: 12px"
      >
        <el-tooltip v-if="count" :content="countTooltipText">
          <span class="box small info-text self-flex-start">
            <i :class="countIcon" />{{ count }}</span
          >
        </el-tooltip>
        <span v-if="percent" class="box small info-text self-flex-start"
          ><i class="mdi mdi-percent" />{{ percent }}</span
        >

        <!-- <slot name="moreIcons"></slot> -->
      </div>
      <!-- caja izquierda, pasa mas iconos evitando se vea el primer icono por default-->
      <div
        v-if="count == 0"
        class="box flex column justify-flex-end col-3"
        style="font-weight: 200; font-size: 12px"
      >
        <slot name="moreIcons"></slot>
      </div>
    </div>

    <div class="widget-header" v-if="text == 'Total de GPS'">
      <!-- caja derecha -->
      <div class="box flex justify-flex-end col-9">
        <div class="box widget-icon-box mr-10 animated fadeInRight">
          <slot name="icon">
            <i class="widget-icon accent-text fs-30" :class="icon"></i>
          </slot>
        </div>
        <div
          class="widget-info box grow animated fadeInLeft flex column justify-flex-start align-content-flex-end"
        >
          <el-row>
            <el-col :span="12">
              <div class="o-050 widget-title">
                {{ text }}
              </div>
              <el-tooltip
                class="item box"
                effect="dark"
                :content="total.toString()"
                placement="top-start"
              >
                <span class="pb-0 pl-0 black-text" style="font-weight: 700">
                  <slot name="total" :total="total">{{
                    total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}</slot>
                </span>
              </el-tooltip>
            </el-col>
            <el-col :span="12" v-if="text == 'Total de GPS'">
              <el-row class="GPS">
                <div class="o-050 widget-title">
                  {{ text2 }}
                </div>
                <el-tooltip
                  class="item box"
                  effect="dark"
                  :content="total2.toString()"
                  placement="top-start"
                >
                  <span class="pb-0 pl-0 black-text" style="font-weight: 700">
                    <slot name="total" :total="total2">{{
                      total2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}</slot>
                  </span>
                </el-tooltip>
              </el-row>
              <el-row class="GPS">
                <div class="o-050 widget-title">
                  {{ text3 }}
                </div>
                <el-tooltip
                  class="item box"
                  effect="dark"
                  :content="Diference.toString()"
                  placement="top-start"
                >
                  <span class="pb-0 pl-0 black-text" style="font-weight: 700">
                    <a href="#" @click.prevent="openDetail"
                      ><slot name="total" :total="Diference">{{
                        Diference.toString().replace(
                          /\B(?=(\d{3})+(?!\d))/g,
                          ","
                        )
                      }}</slot></a
                    >
                    <DifNavisionNavixy :drawer.sync="drawer" :items="items" />
                  </span>
                </el-tooltip>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- caja izquierda -->

      <!-- caja izquierda, pasa mas iconos evitando se vea el primer icono por default-->
    </div>
  </el-card>
</template>

<script>
import DifNavisionNavixy from "@/components/functionals/DifNavisionNavixy.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CardTotalOriginal",
  components: { DifNavisionNavixy },
  created() {},
  props: {
    total: {
      type: [Number, String]
    },
    total2: {
      type: [Number, String]
    },
    Diference: {
      type: [Number, String]
    },
    text: {
      type: String
    },
    text2: {
      type: String
    },
    text3: {
      type: String
    },
    icon: {
      type: String,
      default: "mdi mdi-account-multiple"
    },
    loading: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    },
    percent: {
      type: Number,
      required: false
    },
    countTooltipText: {
      type: String,
      default: "Cantidad de clientes",
      required: false
    },
    countIcon: {
      type: String,
      default: "el-icon-user",
      required: false
    }
  },
  data() {
    return {
      asyncComponent: "peity",
      difTotal: 0,
      difLoading: false,
      drawer: false,
      qtyEquipment: 0,
      items: []
    };
  },
  computed: {
    ...mapGetters({
      // map `this.doneCount` to `this.$store.getters.doneTodosCount`
      getTrackers: "navixy/getTrackers",
      getUserList: "navixy/getUserList"
    })
  },
  methods: {
    ...mapActions({
      getUserListAction: "navixy/getUserList"
      //UpdateNavixyUser: "navixy/updateNavixyUser"
      //ObtainActualUserInfo: "navixy/ObtainActualUserInfo",
    }),
    async openDetail() {
      await this.getReport();
      await this.getUserListAction();
      //console.log("tRACKERS FROM STORE NAVIXY", this.getTrackers);
      //console.log("Usuarios por client code", this.getUserList);
      this.drawer = true;
    },
    getReport() {
      this.loading = true;
      this.$http
        .get("/api/navixy/GetReportDiffNavixyVsNavision", {
          timeout: 3 * 60 * 1000
        })
        .then((resp) => {
          const { details } = resp.data;
          //this.total = stat.TotalLines;
          //this.qtyEquipment = stat.DIFF;
          this.items = details;
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables";

.widget {
  /* height: auto; */
  /* position: relative; */

  .widget-header {
    .widget-icon-box {
      background: rgba(0, 0, 0, 0.02);
      border: 1px solid rgba(0, 0, 0, 0.02);
      border-radius: 4px;
      text-align: center;
      /* min-width: 60px; */
      padding: 5px;
    }

    .widget-title {
      font-weight: bold;
    }
  }

  .badge-box {
    .badge {
      display: inline-block;
      border-radius: 4px;
      font-size: 80%;
    }
  }
}

@media (min-width: 768px) and (max-width: 1040px) {
  .widget {
    .widget-header {
      .widget-icon-box {
        display: none;
      }
    }
  }
}

.GPS {
  padding: 0px;
  margin: 0px;
}
</style>
